import React from 'react';

const Spacer = () => {
  return (
    <div style={{ height: "80px"}} />
  )
}

export default Spacer;